import {
  Box,
  Container,
  Hidden,
  makeStyles,
} from '@material-ui/core';
import cx from 'classnames';
import {NormalizedRoutes} from 'common/types';
import UserMenu from 'components/UserMenu/index';
import React, {FunctionComponent, lazy, Suspense} from 'react';
import {Switch} from 'react-router-dom';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import Footer from 'screens/common/Footer';
import Loading from 'screens/common/Loading';
import PrivateRoute from 'screens/common/PrivateRoute';
import {UserAlerts} from 'screens/common/UserAlerts';
import Header from 'screens/MainLayout/Header/index';
import MobilePanelBottom from 'screens/MainLayout/MobilePanelBottom';
import {iosVersion, rieltor} from 'styles/theme';
import {useSessionStorage} from 'react-use';
import {SessionStorageKey} from '../../common/types';
import {BottomBarForIos26} from '../../components/BottomBarForIos26';

const OfferDetailsScreen = lazy(() =>
  import('screens/offers/OfferDetailsScreen')
);
const PaymentScreen = lazy(() => import('screens/PaymentScreen'));
const OlxImportScreen = lazy(() => import('screens/OlxImportScreen'));
const OlxMigrationScreen = lazy(() => import('screens/OlxMigrationScreen'));
const ReferralsScreen = lazy(() => import('screens/ReferralsScreen'));
const AgencyFeedScreen = lazy(() => import('screens/AgencyFeedScreen'));
// const DealsScreen = lazy(() => import('screens/DealsScreen'));
const DealsScreen = lazy(() => import('screens/DealsScreen/index_new'));
const OffersManagementScreen = lazy(() =>
  import('screens/offers/OffersManagement/index_new')
);

const ProfileIndexScreen = lazy(() =>
  import('screens/profile/ProfileIndexScreen')
);

const AgentsSuggestionsScreen = lazy(() =>
  import('screens/AgentsSuggestionsScreen')
);

const DashboardScreen = lazy(() =>
  import('screens/DashboardScreen')
);

const RieltorsScreen = lazy(() =>
  import('screens/RieltorsScreen')
);

const ObjectsScreen = lazy(() =>
  import('screens/ObjectsScreen'),
);

const RieltorManifestScreen = lazy(() =>
  import('screens/RieltorManifestScreen')
);

const MarketActivityScreen = lazy(() => import('screens/MarketActivityScreen'));
const Conference2025Screen = lazy(()=> import('screens/Conference2025'));

const IbanPaymentScreen = lazy(() => import('screens/IbanPayment'));
const IbanPaymentPreviewScreen = lazy(() => import('screens/IbanPaymentPreview'));

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('xs')]: {
      paddingBottom: theme.spacing(6),
    },
  },
  content: {
    minHeight: 'calc(100vh - 160px)', // 100 % - header height
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: rieltor.grayBody,
  },
  newBg: {
    backgroundColor: rieltor.grayLines
  }
}));

export interface MainLayoutProps extends RouteComponentProps {}

const MainLayout: FunctionComponent<MainLayoutProps> = ({
  location: {pathname},
}: MainLayoutProps) => {
  const classes = useStyles();

  // FIXME: move bg style to global styles when all pages done
  const hasNewBackground = [
    '/dashboard',
    '/deals',
    '/partners',
    NormalizedRoutes.Rieltors,
    '/profile/agents',
    '/profile/subscription',
    '/offers/management',
    '/agency-feed',
    '/internet-offers',
    '/market',
    NormalizedRoutes.Objects,
    '/conference2025',
      NormalizedRoutes.IbanPayments
  ].includes(pathname);

  // debugger;

  return (
    <Box className={classes.root}>
      <Header />
      <Box className={cx(classes.content, {[classes.newBg]: hasNewBackground})}>
        <Hidden smDown>
          <UserMenu/>
        </Hidden>
        {iosVersion >= 26 && <BottomBarForIos26/>}
        {iosVersion >= 26 && <Box style={{backgroundColor: rieltor.mainBg, position: 'fixed', top: 0, left: 0, width: '100%', minHeight: 6, zIndex: 100}}></Box>}
        <Container maxWidth={'xl'} style={{padding: '0 16px'}}>
          <UserAlerts />
        </Container>

        <Suspense fallback={<Loading />}>
          <Switch>
            <PrivateRoute
                path="/dashboard"
                exact
                component={DashboardScreen}
            />
            <PrivateRoute
              path="/offers/management"
              exact
              component={OffersManagementScreen}
            />
            <PrivateRoute
              path="/offers/create/page-:pageId?"
              exact
              component={OfferDetailsScreen}
            />
            <PrivateRoute
              path="/offers/create/agency-:feedId?"
              exact
              component={OfferDetailsScreen}
            />
            {/*<PrivateRoute*/}
            {/*  path="/offers/createold"*/}
            {/*  component={OfferDetailsScreen}*/}
            {/*/>*/}
            <PrivateRoute
              path="/offers/create"
              component={OfferDetailsScreen}
            />
            {/*<PrivateRoute*/}
            {/*  path="/offers/editold/:offerId"*/}
            {/*  component={OfferDetailsScreen}*/}
            {/*/>*/}
            <PrivateRoute
              path="/offers/edit/:offerId"
              component={OfferDetailsScreen}
            />
            <PrivateRoute path="/payment" exact component={PaymentScreen} />
            <PrivateRoute path="/deals" exact component={DealsScreen} />
            <PrivateRoute path="/internet-offers" exact component={OlxImportScreen} />
            <PrivateRoute path="/agency-feed" exact component={AgencyFeedScreen} />

            <PrivateRoute
              path="/agents-suggestions/:offerId"
              exact
              component={AgentsSuggestionsScreen}
            />
            <PrivateRoute path="/profile" component={ProfileIndexScreen} />
            <PrivateRoute path="/referrals" component={ReferralsScreen} />

            <PrivateRoute path="/olx-migration" component={OlxMigrationScreen} />
            <PrivateRoute path={NormalizedRoutes.Rieltors} component={RieltorsScreen} />
            <PrivateRoute path={NormalizedRoutes.Objects} component={ObjectsScreen} />
            <PrivateRoute path="/rieltor-manifest" component={RieltorManifestScreen} />
            <PrivateRoute path="/market" component={MarketActivityScreen} />
            <PrivateRoute path={NormalizedRoutes.IbanPayments} exact component={IbanPaymentScreen} />
            <PrivateRoute path={`${NormalizedRoutes.IbanPaymentsPreview}/:paymentId`} exact component={IbanPaymentPreviewScreen} />
            {/*<PrivateRoute path="/conference2025" component={Conference2025Screen} />*/}

          </Switch>
        </Suspense>
      </Box>

      <Hidden xsDown>
        <Footer />
      </Hidden>

      <Hidden mdUp>
        <MobilePanelBottom pathname={pathname}/>
      </Hidden>
    </Box>
  );
};

export default withRouter(MainLayout);
